import React from "react";
import useStyles from "./styles";
import { FormGroup, InputBase, FormHelperText } from "@material-ui/core";
import { useTranslation } from 'react-i18next';
import ApmPayButton from '../ApmPayButton';

const PostFinance = ({ currentPaymentSystem, formik, errorString }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.wrapper}>
      <FormGroup className={classes.cardForm}>
        <p className={`${classes.cardText} input_label_text`}>{t('Payer_name')}</p>
        <InputBase
          error={!!(formik.errors.cardName)}
          className={classes.cardInput}
          label={t('Payer_name')}
          name="cardName"
          value={formik.values.cardName?.toUpperCase()}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          variant="outlined"
          placeholder={t('Payer_name')}
          fullWidth
          inputProps={{
            maxLength: 100,
          }}
        />
        {
          formik.errors?.cardName && (
            <FormHelperText className='error_text' error>{formik.errors?.cardName}</FormHelperText>
          )
        }
      </FormGroup>
      <ApmPayButton currentPaymentSystem={currentPaymentSystem} errorString={errorString} />
    </div>
  )
}

export default PostFinance
